/**
 * Idle Timer Warning Modal Component
 * Displays session expiration warning with countdown
 * Auto-dismisses when countdown reaches zero
 */

import React from 'react';
import '../styles/IdleTimerModal.css';

interface IdleTimerModalProps {
  isVisible: boolean;
  timeRemaining: number;
  formattedTime: string;
  onExtendSession?: () => void;
  onLogout?: () => void;
}

/**
 * Modal warning component shown before session expires
 * Automatically disappears when countdown reaches zero
 */
export const IdleTimerModal: React.FC<IdleTimerModalProps> = ({
  isVisible,
  timeRemaining,
  formattedTime,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <>
      {/* Overlay backdrop */}
      <div className="idle-timer-overlay" />

      {/* Modal */}
      <div className="idle-timer-modal">
        <div className="idle-timer-modal-content">
          {/* Header */}
          <div className="idle-timer-header">
            <h2 className="idle-timer-title">
              <span className="warning-icon">⏰</span>
              Session Expiring Soon
            </h2>
          </div>

          {/* Body */}
          <div className="idle-timer-body">
            <p className="idle-timer-message">
              Your session will expire due to inactivity
            </p>

            {/* Countdown Display */}
            <div className="countdown-display">
              <div className="countdown-time">{formattedTime}</div>
              <div className="countdown-label">seconds remaining</div>
            </div>

            {/* Progress Bar */}
            <div className="countdown-progress-container">
              <div
                className="countdown-progress"
                style={{
                  width: `${(timeRemaining / 10000) * 100}%`,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IdleTimerModal;
